<template>
    <section class="intro-videos">

            <div class="panel-body" v-if="terms">
                <p>These Videos show up per group, per week - a personalized video each week for how things are going!</p>
           
           <div class="panel" v-if="terms">
                <div class="panel-heading"><h2>Add a Weekly Intro Video</h2></div>
                <div class="panel-body add-weekly-video">
                    <p>Below you can add your personalized weekly intro videos, per week</p>
                    <form @submit.prevent="addVideo()" v-if="supervisorGroups">
                        <div class="form-group">
                            <label>Term</label>
                            <select class="form-control" v-model="term">
                                <option v-for="term in terms" :value="term.id">{{term.name}}</option>
                            </select>
                            <label>Week</label>
                            <select class="form-control" v-model="week">
                                <option value="0">Pre-term</option>
                                <option v-for="week in weeks" :value="week">Week {{week}}</option>
                            </select>
                            <label>Group</label>
                            <select class="form-control" v-model="selectedGroup">
                                <option 
                                v-for="group in supervisorGroups" 
                                v-if="group.term==term"
                                :value="group.id">
                                    Group {{group.label}}
                                </option>
                            </select>
                            <input @change="validateFileType()" type="file" class="form-control" ref="supervisorVideo" accept="video/mp4">
                            <button type="submit" class="btn btn-primary">Add</button>


                    </div>
                </form>

            </div>      
        
                <div v-for="(videos, term) in videos" class="panel">
                    <div class="panel-heading cursor-pointer" @click="selectedTerm === term  ? selectedTerm = null : selectedTerm = term">
                            <h4>
                                {{formatDate(term)}}
                                <i class="fa fa-caret-down" v-if="selectedTerm===term"></i>
                                <i v-else class="fa fa-caret-right"></i>
                            </h4>
                        </div>
                        <div class="panel-body videos-table" v-if="selectedTerm === term">
                            <div v-for="video in videos" class="video">
                                <div class="row">
                                    <div class="week">
                                        <span v-if="video.week < 1">Pre-Term</span><span v-else>Week {{video.week}}</span>
                                    </div>
                                    <div>
                                        {{video.groups[0].label || video.groups[0]}}
                                    </div>
                                    <div>
                                        <button @click="deleteVideo(video.id)" class="btn btn-danger">Delete</button>
                                    </div>
                                   
                                    <div>
                                        <a :href="video.url" target="_blank">Link</a>
                                    </div>
                                    <div @click.prevent="selectedVideo === video.id ? selectedVideo = null : selectedVideo = video.id" class="cursor-pointer video-thumbnail">
                                        <img src="../assets/img/play-button.png" />
                                        <video width="100">
                                            <source :src="video.url">
                                        </video>
                                    </div>
                                </div>
                                <div v-if="selectedVideo === video.id" class="player">
                                     <poly-video 
                                        ref="videoPlayer" 
                                        :key="selectedVideo.id" 
                                        :sources="[ video.url ]" 
                                        :persistPlaybackSpeed="true">
                                    </poly-video>
                                </div>
                            </div>
                            <!--  <table class="table table-striped table-bordered">
                                <thead>        
                                    <tr>    
                                        <th>Week</th>
                                        <th>Group</th>
                                        <th></th>
                                        <th></th>
                                    </tr>                           
                                </thead>
                                <tbody>
                                    <table v-for="video in videos" class="table table-striped table-bordered">                   
                                        <thead>                                             
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{video.week + 1}}</td>
                                                <td>{{video.groups[0].label || video.groups[0]}}</td>
                                                <td> <button @click="deleteVideo(video.id)" class="btn btn-danger">Delete</button></td>
                                                <td><a :href="video.url" target="_blank">Open</a></td>
                                            </tr>
                                        </tbody>
                                    </table>                                                                      
                                </tbody>
                            </table>  -->
                        </div>
                        
                </div>
                </div>
            
           
 
            </div>
        </div>

    </div>
</section>
</template>


<script>
    import terms from '../services/terms';
    import users from '../services/users';
    import introVideos from '../services/intro-videos';
    import aws from '../services/aws';

    import moment from 'moment';
    import toastr from 'toastr';
    
    import _ from 'lodash';
    import PolyVideo from './reusable/poly-video';

    export default {
        data() {
            return {
                weeks: 16,
                week:null,
                terms: null,
                term:null,
                videos: [],
                supervisorGroups: null,
                selectedGroup: null,
                selectedTerm: null,
                selectedVideo: null,
               
            }
        },
        components: {
            PolyVideo
        },
        async mounted() {
            await this.getTerms();
            this.getVideos();
            this.getGroups();
        },
        methods: {
            validateFileType() {
                let type = this.$refs.supervisorVideo.files[0].type;
                if (type != 'video/mp4') {
                    toastr.error('Please upload an MP4 video');
                    this.$refs.supervisorVideo.value = null;
                }
            },
            formatDate(d) {                
                const dateObj = new Date(d);
                if (dateObj instanceof Date && !isNaN(dateObj)) {
                    return moment(d).format('MMMM YYYY')
                }
                return 'Term not in account';
            },
            termName(id) {
                let index = this.terms.findIndex(function(t) { return t.id == id });
                if (index > -1) return this.terms[index].name;
            },
            getGroups() {
                var self = this;
                var supervisorGroups = localStorage.group.split(',');
                users.getGroups(this).then(function(response) {
                    self.supervisorGroups = response.data.groups.filter(function(g) {
                        return supervisorGroups.indexOf(g.id.toString()) > -1;
                    });
                 
                });
            },
            getVideos() {
                var self = this;

                function getTermStart(id) {
                    const t =  self.terms.find(function(t) { return t.id == id });
                    if (t) {
                        return t.startDate;
                    }
                    else {
                        return 'Date unknown'
                    }
                }
                introVideos.get(this).then(function(response) {
                    
                    self.videos = response.data.videos;
                    let vids = response.data.videos.map((v)=>{                       
                        v.term = getTermStart(v.term);
                        return v;
                    });
                    vids = _.groupBy(vids, 'term');
                    
                    vids = Object.keys(vids)
                        .sort((a,b)=>{ return new Date(b) - new Date(a); })
                        .reduce((acc, key) => ({
                            ...acc, [key]: vids[key]
                        }), {});

                    for (const key of Object.keys(vids)) {
                        vids[key] = vids[key].sort((a,b)=>{ return a.week - b.week });
                    }
                    self.videos = vids;                    

                });
            },
            deleteVideo(id) {
                var self = this;
                introVideos.delete(this,id).then(function(response) {
                    if (response.data.success === true) {
                        toastr.success('Video deleted');
                        self.getVideos();    
                    } else {
                        toastr.error(response.data.message || 'Error deleting video')
                    }
                    
                });

            },
            addVideo() {
                var self = this;

                if (!self.term || !self.week || !self.selectedGroup) {
                    toastr.error('Please select a week, term, and group');
                    return false;
                }

                var video = {
                    term: self.term,
                    week: parseInt(self.week),
                    supervisorId: localStorage.user_id,
                    groups: [self.selectedGroup]
                }


                const uuidV4 = require('uuid/v4');
              
                const file = this.$refs.supervisorVideo.files[0];
                const filename = uuidV4() + '.' + file.name.split('.').pop();

                aws.signature(file, filename, 'ttto-intro-videos').then(function(signature) {

                    aws.getPresignedUrl(self, 'ttto-intro-videos', filename, 'putObject').then(function(presignedUrl) {

                     aws.upload(file, filename, signature, 'ttto-intro-videos', presignedUrl.data).then(function(response) {   

                        if (response.success === true) {
                            video.url = response.url
                            introVideos.create(self, video).then(function(response) {
                                
                                if (response.data.success === true) {
                                    toastr.success('Video Added');
                                    self.getVideos();
                                } else {
                                    toastr.error('Error adding video');
                                }
                            })
                        } else {
                            alert('Error uploading');
                            resolve(false);
                        }
                    });
                 });

                });

            },
            getTerms() {
                var self = this;
                return terms.getSupervisorTerms(this).then(function(response) {
                    self.terms = response.data.terms.sort(function(a, b) { return new Date(a.startDate) - new Date(b.startDate) });
                    self.getGroups();
                    return true;
                });
               
            },
        },
        computed: {
            // supervisorGroups() {
            //     return localStorage.group.split(',')
            // }
        }
    }
</script>

<style lang="scss" scoped>

.week {
    width:80px;
}

.cursor-pointer { cursor:pointer }

.player {
    border-left:1px solid #ccc;
    border-right:1px solid #ccc;
}

.videos-table {
    .row {
        display:flex;
        align-items:center;
        justify-content: space-around;        
        border:1px solid #ccc;
        border-bottom:none;
        padding:1rem 0;        
        & > div {
            flex-grow:1;        
            display:flex;
            align-items:center;
            justify-content:center;            
        }
        & > div:nth-child(2) {            
            width:260px;
        }
    }
    .video:last-child {
        border-bottom: 1px solid #ccc;
    }
}

.videos {
    video {
        //max-width:130%;
    }
    span {
        display:block;
    }
    form {
        padding:1rem;
    }
}

.panel-body {padding:20px!important;}


.form-control:not([type="file"]) {
    background: rgba(0, 0, 0, 0.2) !important;
    margin-bottom: 20px;
}

.video-thumbnail {
    position:relative;
  
    video {
        top:0;
        left:0;
        
    }
    img {
        width:30px;
        height:30px;
        position:absolute;
        top:12px;
        z-index:9999;
        opacity:.75;

    }
}
//.add-weekly-video {
//    padding:20px!important;
//}
</style>


// WEBPACK FOOTER //
// IntroVideos.vue?322247ab